import { put, takeLatest, call } from 'redux-saga/effects'
import fetchFromAPI, { getDefaultAutorizedHeaders } from 'helpers/fetchFromApi'
import UrlHelper from 'helpers/url'
import NoticeHelper from 'helpers/notice'
import { SHOW_NOTICE } from 'reducers/notice'

import * as ApiRouter from 'constants/apiRouting'
import { createSiteGroupForm } from 'helpers/siteCroup'
import {
  FETCH_SITE_GROUP_LIST,
  SUCCESS_SITE_GROUP_LIST,
  FAILURE_SITE_GROUP_LIST,
  LOAD_SITE_GROUP_LIST,
  FETCH_SITE_GROUP_TABLE,
  SUCCESS_SITE_GROUP_TABLE,
  FAILURE_SITE_GROUP_TABLE,
  LOAD_SITE_GROUP_TABLE,
  FETCH_SITE_GROUP_FORM,
  SUCCESS_SITE_GROUP_FORM,
  FAILURE_SITE_GROUP_FORM,
  LOAD_SITE_GROUP_FORM,
  SET_SITE_GROUP_INFO,
  DELETE_SITE_GROUP_INFO,
} from './reducer'
import { API_URL_SITE_LIST } from '../../constants'

function* fetchSiteGroupList(action) {
  try {
    yield put({ type: LOAD_SITE_GROUP_LIST, payload: true })

    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: `${ApiRouter.SITE_GROUPS}${UrlHelper.getPsfsQuery(
        action.payload,
      )}`,
    })

    if (!Object.prototype.hasOwnProperty.call(response, 'error')) {
      yield put({
        type: SUCCESS_SITE_GROUP_LIST,
        payload: response,
      })
    } else {
      yield put({ type: FAILURE_SITE_GROUP_LIST })
    }

    yield put({ type: LOAD_SITE_GROUP_LIST, payload: false })
  } catch (error) {
    console.log('LOAD SITE GROUP LIST ERROR', error)
  }
}

function* fetchSiteGroupTable(action) {
  try {
    yield put({ type: LOAD_SITE_GROUP_TABLE, payload: true })

    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: `${ApiRouter.SITE_GROUP_TABLE}${UrlHelper.getPsfsQuery(
        action.payload,
      )}`,
    })

    if (!Object.prototype.hasOwnProperty.call(response, 'error')) {
      yield put({
        type: SUCCESS_SITE_GROUP_TABLE,
        payload: response,
      })
    } else {
      yield put({ type: FAILURE_SITE_GROUP_TABLE })
    }

    yield put({ type: LOAD_SITE_GROUP_TABLE, payload: false })
  } catch (error) {
    console.log('LOAD SITE GROUP TABLE ERROR', error)
  }
}

function* fetchSiteGroupForm({ payload }) {
  try {
    yield put({ type: LOAD_SITE_GROUP_FORM, payload: true })

    const { entityId } = payload
    const formData = createSiteGroupForm()

    formData.sites = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: API_URL_SITE_LIST,
    })

    if (entityId) {
      formData.siteGroup = yield call(fetchFromAPI, {
        headers: getDefaultAutorizedHeaders(),
        partUrl: UrlHelper.create(ApiRouter.SITE_GROUP_INFO, { id: entityId }),
      })
    }

    if (
      formData.sites &&
      !Object.prototype.hasOwnProperty.call(formData.sites, 'error') &&
      (!formData.siteGroup ||
        !Object.prototype.hasOwnProperty.call(formData.siteGroup, 'error'))
    ) {
      yield put({
        type: SUCCESS_SITE_GROUP_FORM,
        payload: formData,
      })
    } else {
      yield put({ type: FAILURE_SITE_GROUP_FORM })
    }

    yield put({ type: LOAD_SITE_GROUP_FORM, payload: false })
  } catch (error) {
    console.log('LOAD SITE GROUP FORM ERROR', error)
  }
}

function* setSiteGroupInfo({ payload, promise }) {
  try {
    const { entityId, values } = payload
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: !entityId
        ? ApiRouter.SITE_GROUPS
        : UrlHelper.create(ApiRouter.SITE_GROUP_INFO, { id: entityId }),
      method: !entityId ? 'POST' : 'PUT',
      data: values,
    })

    if (response.error) {
      return yield call(promise.resolve, response.errors)
    }

    yield put({
      type: SHOW_NOTICE,
      notice: NoticeHelper.createSuccessObj(
        `Site ${entityId === 0 ? 'create' : 'change'} successful`,
      ),
    })

    return yield call(promise.resolve, false)
  } catch (error) {
    throw new Error(`UNKNOW SITE CHANGE ERROR. DATA: ${error}`)
  }
}

function* deleteSiteGroupInfo(action) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      method: 'DELETE',
      partUrl: UrlHelper.create(ApiRouter.SITE_GROUP_INFO, {
        id: action.payload.entityId,
      }),
    })

    if (response === 204) {
      yield put({
        type: SHOW_NOTICE,
        notice: NoticeHelper.createSuccessObj('Site delete successful'),
      })

      return yield fetchSiteGroupTable(action)
    }
  } catch (error) {
    console.log('SITE INTERFACE ERROR', error)
  }
}

function* siteGroupSaga() {
  yield takeLatest(FETCH_SITE_GROUP_LIST, fetchSiteGroupList)
  yield takeLatest(FETCH_SITE_GROUP_TABLE, fetchSiteGroupTable)
  yield takeLatest(FETCH_SITE_GROUP_FORM, fetchSiteGroupForm)
  yield takeLatest(SET_SITE_GROUP_INFO, setSiteGroupInfo)
  yield takeLatest(DELETE_SITE_GROUP_INFO, deleteSiteGroupInfo)
}

export default siteGroupSaga
